// @flow
import React, { Component } from 'react'
import LimitedInput from './LimitedInput'
import LabeledInput from './LabeledInput'

type Props = {|
  value: string,
  header: string,
  maxLength: number,
  errors?: Array<string>,
  placeholder?: string,
  className?: string,
  multiline?: boolean,
  onChange?: (string) => void
|}

export default class TextInput extends Component<Props> {
  render() {
    const {
      value,
      maxLength,
      errors,
      onChange,
      placeholder,
      className,
      header,
      multiline
    } = this.props

    return (
      <div className={className}>
        <LabeledInput
          header={header}
          input={
            <LimitedInput
              value={value}
              maxLength={maxLength}
              multiline={!!multiline}
              placeholder={placeholder || ''}
              onChange={(val) => onChange && onChange(val)}
            />
          }
          errors={errors}
        />
      </div>
    )
  }
}
